export default __webpack_public_path__ + "static/media/misc-makeupA-2048w.aa58083d.png";